import React from 'react';
import logo3 from "../assets/img/kariyernet.png";
import logo4 from "../assets/img/linkedin.png";

const Social = () => {
    return (
        <>
            <ul
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '12px',
                    padding: 0,
                    margin: 0,
                    listStyle: 'none'
                }}
            >
                <li>
                    <a href="https://www.kariyer.net/firma-profil/ayyildiz-insaat-san-tic-ltd-sti-52798-168891" target="_blank" rel="noreferrer">
                        <img
                            src={logo3}
                            alt="Kariyer.net"
                            style={{ width: '90px', height: '75px', objectFit: 'contain', marginLeft: '12px'}}
                        />
                    </a>
                </li>
                <li>
                    <a href="https://tr.linkedin.com/in/selma-ayyildiz-699a99174" target="_blank" rel="noreferrer">
                        <img
                            src={logo4}
                            alt="LinkedIn"
                            style={{ width: '100px', height: '75px', objectFit: 'contain' }}
                        />
                    </a>
                </li>
            </ul>
        </>
    );
};

export default Social;